
import { Component, Prop, Vue } from "vue-property-decorator";
import PModal from "@/components/look/PModal.vue";
import QrcodeVue from "qrcode.vue";
import pako from "pako";
import { PropType } from "vue";

@Component({
  name: "qr-modal",
  components: {
    PModal,
    QrcodeVue,
  },
})
export default class QRModal extends Vue {
  @Prop({ required: true, default: "", type: Array as PropType<string[]> }) values!: string[];
  @Prop({ required: true, default: "", type: String }) serviceCode!: string;

  gzipBase64Encode(input: string): string {
    // Convierte el string a un array de bytes
    const textEncoder = new TextEncoder();
    const inputBytes = textEncoder.encode(input);

    // Comprime los bytes usando gzip
    const compressedBytes = pako.gzip(inputBytes);

    // Convierte los bytes comprimidos a un string base64
    return btoa(String.fromCharCode(...compressedBytes));
  }
}
